import React, { useEffect, useState } from "react";
import { Grid, Typography, Divider, Box } from "@mui/material";

import axiosClient from "../axiosClient";
import { useStateContext } from "../context/ContextProvider";

const ZReport = ({ fromDate, toDate }) => {
  const { store } = useStateContext();

  const [data, setData] = useState();
  const [payout, setPayout] = useState();
  const [receivable, setReceivable] = useState();

  useEffect(() => {
    const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g, "");
    const databaseStoreName = `DB301_${
      JSON.parse(store).id
    }_${correctStoreName}`;

    const payload = {
      shopName: databaseStoreName,
      from: fromDate,
      to: toDate,
    };
    axiosClient
      .post("reports/sales/zanalysis", payload)
      .then((response) => {
        setData(response.data.data);
        setPayout(response.data.payout);
        setReceivable(response.data.receivable);
      })
      .catch((err) => console.log(err));
  }, [store, fromDate, toDate]);

  const formatDate = (dateString) => {
    const parts = dateString.split("-");
    if (parts.length === 3) {
      const [year, month, day] = parts;
      return `${day}/${month}/${year}`;
    } else {
      return "Invalid Date";
    }
  };

  function convertSqlDateTimeToDdMmYyyy(dateTimeString) {
    const [datePart, timePart] = dateTimeString.split("T");
    const [year, month, day] = datePart.split("-");

    return `${day}/${month}/${year}`;
  }

  function sumAttribute(array, attribute) {
    const attributeValues = array.map((obj) => obj[attribute]);
    const sum = attributeValues.reduce(
      (acc, currentValue) => acc + currentValue,
      0
    );

    return parseFloat(sum).toFixed(2);
  }

  function sumProduct(array, attribute1, attribute2) {
    const sum = array.reduce((acc, obj) => {
      const productPlus = obj[attribute1] - ((obj[attribute1] * 100) / (obj[attribute2] + 100));
      return acc + productPlus;
    }, 0);

    return parseFloat(sum).toFixed(2);
  }

  function sumAttributeIf(
    array,
    conditionAttribute,
    conditionValue,
    sumAttribute
  ) {
    return array.reduce((accumulator, currentValue) => {
      if (currentValue[conditionAttribute] === conditionValue) {
        return accumulator + currentValue[sumAttribute];
      } else {
        return accumulator;
      }
    }, 0);
  }

  function sumProductIf(
    array,
    conditionAttribute,
    conditionValue,
    attribute1,
    attribute2
  ) {
    return array.reduce((accumulator, currentValue) => {
      if (currentValue[conditionAttribute] === conditionValue) {
        return (
          accumulator +
          (currentValue[attribute1] - (currentValue[attribute1] * 100) / (currentValue[attribute2] + 100))
        );
      } else {
        return accumulator;
      }
    }, 0);
  }

  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="inherit">Z analysis</Typography>
        <Typography variant="caption">{` ${formatDate(fromDate)} - ${formatDate(
          toDate
        )}`}</Typography>
        <Divider />
      </Grid>
      <Grid item container xs={12}>
        <Grid item xs={2}>
          <Typography variant="body1" align="center">
            Z-number
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body1" align="center">
            Date
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body1" align="center">
            Vat Rate
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body1" align="center">
            Total Amount
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body1" align="center">
            Vat Amount
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body1" align="center">
            Net Amount
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            <Divider />
          </Box>
        </Grid>
      </Grid>
      {data.map((z, index, data) => {
        const nextValue =
          index + 1 < data.length ? data[index + 1].z_number : 0;

        const previousValue = index > 0 ? data[index - 1].z_number : 0;

        return (
          <Grid item container xs={12} key={index + 1}>
            <Grid item xs={2}>
              {previousValue !== z.z_number ? (
                <Typography variant="body1" align="center">
                  {z.z_number}
                </Typography>
              ) : null}
            </Grid>
            <Grid item xs={2}>
              {previousValue !== z.z_number ? (
                <Typography variant="body2" align="center">
                  {convertSqlDateTimeToDdMmYyyy(z.z_date)}
                </Typography>
              ) : null}
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" align="center">
                {`${z.vat_rate}%`}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" align="center">
                {parseFloat(z.totalPrice).toFixed(2)}
              </Typography>
              {nextValue !== z.z_number ? (
                <Grid>
                  <Box mt={1} mb={1}>
                    <Divider />
                  </Box>
                  <Typography variant="body2" align="center">
                    {sumAttributeIf(
                      data,
                      "z_number",
                      z.z_number,
                      "totalPrice"
                    ).toFixed(2)}
                  </Typography>
                </Grid>
              ) : null}
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" align="center">
                {parseFloat(
                  z.totalPrice - (z.totalPrice * 100) / (100 + z.vat_rate)
                ).toFixed(2)}
              </Typography>
              {nextValue !== z.z_number ? (
                <Grid>
                  <Box mt={1} mb={1}>
                    <Divider />
                  </Box>
                  <Typography variant="body2" align="center">
                    {sumProductIf(
                      data,
                      "z_number",
                      z.z_number,
                      "totalPrice",
                      "vat_rate"
                    ).toFixed(2)}
                  </Typography>
                </Grid>
              ) : null}
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" align="center">
                {parseFloat((z.totalPrice * 100) / (100 + z.vat_rate)).toFixed(
                  2
                )}
              </Typography>
              {nextValue !== z.z_number ? (
                <Grid>
                  <Box mt={1} mb={1}>
                    <Divider />
                  </Box>
                  <Typography variant="body2" align="center">
                    {(
                      sumAttributeIf(
                        data,
                        "z_number",
                        z.z_number,
                        "totalPrice"
                      ) -
                      sumProductIf(
                        data,
                        "z_number",
                        z.z_number,
                        "totalPrice",
                        "vat_rate"
                      )
                    ).toFixed(2)}
                  </Typography>
                </Grid>
              ) : null}
            </Grid>
            {nextValue !== z.z_number ? (
              <Grid item xs={12}>
                <Box mt={1} mb={1}>
                  <Divider />
                </Box>
              </Grid>
            ) : null}
          </Grid>
        );
      })}
      <Grid item container xs={12}>
        <Grid item xs={6}>
          <Typography variant="body1" align="center">
            Grand Totals:
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" align="center">
            {sumAttribute(data, "totalPrice")}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" align="center">
            {sumProduct(data, "totalPrice", "vat_rate")}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" align="center">
            {(
              sumAttribute(data, "totalPrice") -
              sumProduct(data, "totalPrice", "vat_rate")
            ).toFixed(2)}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            <Divider />
          </Box>
        </Grid>
      </Grid>
      <Grid item container xs={12}>
        <Grid item xs={6}>
          <Typography variant="body1" align="center">
            Account payouts and receivables:
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" align="center">
            Totals
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" align="center">
            {parseFloat(payout[0].total).toFixed(2)}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" align="center">
            {parseFloat(receivable[0].total).toFixed(2)}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            <Divider />
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ZReport;
